<template>
	<span
		v-if="statusText"
		class="save-status-indicator"
		:class="statusClass"
		:title="lastSavedAt ? `Last saved: ${formatTime(lastSavedAt)}` : ''"
	>
		<span v-if="resolvedIcon" class="save-status-indicator__icon" aria-hidden="true">
			{{ resolvedIcon }}
		</span>
		{{ statusText }}
	</span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
	status: {
		type: String,
		required: true,
	},
	statusText: {
		type: String,
		default: '',
	},
	statusIcon: {
		type: String,
		default: '',
	},
	statusColor: {
		type: String,
		default: '',
	},
	lastSavedAt: {
		type: Date,
		default: null,
	},
})

const statusClass = computed(() => {
	const color = String(props.statusColor || '').toLowerCase()
	if (color.includes('success') || color.includes('green')) return 'save-status-indicator--success'
	if (color.includes('error') || color.includes('danger') || color.includes('red')) return 'save-status-indicator--error'
	if (color.includes('warning') || color.includes('orange') || color.includes('amber')) return 'save-status-indicator--warning'
	return 'save-status-indicator--neutral'
})

const resolvedIcon = computed(() => {
	const icon = String(props.statusIcon || '').toLowerCase()
	if (icon.includes('check')) return '✓'
	if (icon.includes('alert') || icon.includes('error')) return '!'
	if (icon.includes('clock') || icon.includes('time')) return '…'
	return ''
})

const formatTime = (date) => {
	if (!date) return ''

	const now = new Date()
	const diff = Math.floor((now - date) / 1000)

	if (diff < 60) return 'just now'
	if (diff < 3600) return `${Math.floor(diff / 60)} min ago`
	if (diff < 86400) return `${Math.floor(diff / 3600)} h ago`

	return date.toLocaleString('ru-RU', {
		day: '2-digit',
		month: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
	})
}
</script>

<style scoped>
.save-status-indicator {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 4px 10px;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 500;
	line-height: 1;
}

.save-status-indicator__icon {
	font-weight: 700;
}

.save-status-indicator--success {
	color: #166534;
	background: #dcfce7;
}

.save-status-indicator--error {
	color: #991b1b;
	background: #fee2e2;
}

.save-status-indicator--warning {
	color: #92400e;
	background: #fef3c7;
}

.save-status-indicator--neutral {
	color: #334155;
	background: #e2e8f0;
}
</style>
